<template>
    <v-card class="pa-0">
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-expansion-panels>
            <v-expansion-panel v-for="item in medicalRecords" :key="item.MedicalRecordID">
                <v-expansion-panel-header>
                    <v-row class="d-flex flex-row align-center justify-center">
                        <v-col class="font-weight-bold">
                            Medical Record ID: {{item.MedicalRecordID}}
                        </v-col>
                        <v-col class="font-weight-bold">
                            Keywords: {{item.Keywords&&item.Keywords}}
                        </v-col>
                        <v-col class="font-weight-bold">
                            Date: {{formatDate(item.Date)}}
                        </v-col>
                        <v-col class="font-weight-bold">
                            Rest From Extraction:
                            <v-icon
                                v-if="item.RestFromExtraction"
                                color="red"
                                right
                            >
                                mdi-checkbox-marked-circle
                            </v-icon>
                            <v-icon
                                v-if="!item.RestFromExtraction"
                                dark
                                right
                            >
                                mdi-checkbox-marked-circle
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <MedicalRecordEntry :medicalRecordID="item.MedicalRecordID">
                    </MedicalRecordEntry>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import moment from 'moment';

import util from '@/helpers/util';
import constants from 'comunet-btg-utah-repository-shared/constants';
import medicalAPI from '../../services/medicalRecordAPI';
import MedicalRecordEntry from './MedicalRecordEntry.vue';
export default {
    components: {
        MedicalRecordEntry
    },
    props: {
        specimenID: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
        };
    },
    computed: {
         ...mapGetters({
            medicalRecords: "medicalRecordStore/getMedicalRecords",
            loading: "medicalRecordStore/loadInProgress"
        }),
    },
    methods: {
        formatDate(date) {
            return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
        },
    },
    async created() {
        const SpecimenID = this.$route.query.SpecimenID;
        this.$store.dispatch("medicalRecordStore/getMedicalRecords", 
            {
                SpecimenID: SpecimenID,
                openOnly: "false",
                IncludeFollowup: "true"
            }    
            
        );  
    },
    watch: {
       
    },
};
</script>

<style lang="scss" scoped>

</style>